"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IceboxFallback = void 0;
/**
 * IceboxFallback
 *
 * @export
 * @class IceboxFallback
 */
class IceboxFallback {
    /**
     * Creates an instance of the IceboxFallback.
     * @param {EventEmitter} eventEmitter
     * @param {Icebox} icebox
     * @param {IChannelList} channels
     * @param {number} fallbackPollingIntervalSeconds
     * @memberof IceboxFallback
     */
    constructor(eventEmitter, icebox, channels, fallbackPollingIntervalSeconds = 2) {
        // These error codes will not cause the Fallback to happen
        this.errorsCodesToIngore = ['TOKEN_INVALID', 'TOKEN_EXPIRED'];
        if (!eventEmitter)
            throw new Error('EVENT_EMITTER_MISSING');
        if (!icebox)
            throw new Error('ICEBOX_MISSING');
        this.channels = channels;
        this.icebox = icebox;
        this.fallbackPollingIntervalSeconds = fallbackPollingIntervalSeconds;
        this.IsInFallback = false;
        this.onErrorListener = (error) => {
            this.onError(error);
        };
        this.onStatusListener = (status) => {
            this.onStatus(status);
        };
        this.eventEmitter = eventEmitter;
        this.eventEmitter.on('error', this.onErrorListener);
        this.eventEmitter.on('status', this.onStatusListener);
    }
    /**
     * Stops the fallback polling process
     *
     * @return {*}  {void}
     * @memberof IceboxFallback
     */
    stopFallback() {
        if (this.intervalHandle) {
            clearInterval(this.intervalHandle);
            this.intervalHandle = null;
        }
        this.IsInFallback = false;
        if (this.eventEmitter) {
            this.eventEmitter.off('error', this.onErrorListener);
            this.eventEmitter.off('status', this.onStatusListener);
        }
    }
    onStatus(status) {
        // When eventEmitter (e.g. Faucet) reconnects, disable Fallback
        if (this.IsInFallback && status.authenticated) {
            this.stopFallback();
        }
    }
    onError(error) {
        if (!this.errorsCodesToIngore.includes(error.errorCode) &&
            !this.IsInFallback) {
            // Prevent multiple intervals
            if (this.intervalHandle) {
                clearInterval(this.intervalHandle);
                this.intervalHandle = null;
            }
            this.intervalHandle = setInterval(() => {
                void this.onInterval();
            }, this.fallbackPollingIntervalSeconds * 1000);
            this.IsInFallback = true;
            error.message = `[${error.message}] Falling back to polling icebox. Interval: ${this.fallbackPollingIntervalSeconds}s.`;
            this.eventEmitter.emit('error', error);
        }
    }
    async onInterval() {
        // If there's no channels, just bail
        if (!this.channels) {
            return;
        }
        const combined = await this.icebox.combinedSnapshot(this.channels);
        combined.forEach((element) => {
            this.eventEmitter.emit('data', {
                channel: element.channel,
                snapshot: element.data,
                update: element.data
            });
        });
    }
}
exports.IceboxFallback = IceboxFallback;
//# sourceMappingURL=iceboxFallback.js.map